import React from "react";

export default () => (
    <svg
        width="28"
        height="24"
        viewBox="0 0 28 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="3"
            y="3"
            width="22"
            height="18"
            stroke="black"
            strokeWidth="1.5"
        />
        <rect
            x="1.5"
            y="1.5"
            width="3"
            height="3"
            rx="1.5"
            fill="black"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="23.5"
            y="1.5"
            width="3"
            height="3"
            rx="1.5"
            fill="black"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="1.5"
            y="19.5"
            width="3"
            height="3"
            rx="1.5"
            fill="black"
            stroke="black"
            strokeWidth="2"
        />
        <rect
            x="23.5"
            y="19.5"
            width="3"
            height="3"
            rx="1.5"
            fill="black"
            stroke="black"
            strokeWidth="2"
        />
    </svg>
);
